<template>
  <div>
    <main-header-info :navInfoItems="schema.navInfoItems" />
    <pro-login
      :schemaForm="schema.schemaForm"
      :modelForm="model"
      :save="handleLogin"
      :status="status"
    />
    <v-snack-bar :snackbar="snackbar" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import MainHeaderInfo from '@/components/includes/MainHeaderInfo.vue';
import ProLogin from '@/components/enter/ProLogin.vue';
import VSnackBar from '@/components/base/VSnackBar.vue';

export default {
  name: 'ProLoginPage',
  components: {
    MainHeaderInfo,
    ProLogin,
    VSnackBar,
  },
  data() {
    return {
      model: {
        email: '', 
        password: ''
      },
    };
  },
  mounted() {
    this.loadSchema();
  },
  computed: {
    ...mapGetters('proLoginPage', ['schema']),
    ...mapGetters('auth', ['status', 'msgError']),
    ...mapGetters('notifications', ['snackbar']),
  },
  methods: {
    ...mapActions('proLoginPage', ['loadSchema']),
    ...mapActions('notifications', ['triggerSnackbar']),

    async handleLogin() {
      const model = this.model;

      this.$store.dispatch('auth/login', model).then(
        () => {
          if (this.status === 'success') {
            this.$router.push({ name: 'pro-home' });
          } else if (this.status === 'error') {
            this.snackbar.visible = false;
            this.snackbar.visible = true;
            this.snackbar.content = this.msgError;

            this.$store.commit('auth/SET_STATUS', 'loaded');
          }
        },
        () => {
          this.snackbar.visible = false;
          this.snackbar.visible = true;
          this.snackbar.content = this.schema.snackError;

          this.$store.commit('auth/SET_STATUS', 'loaded');
        }
      );
    },
  },
};
</script>
